import styled from "styled-components";

export const Container = styled.button`
    color: ${props => props.blueSchema ? "#030031" : "#f9f9f9"};
    background-color: ${props => props.redSchema ? "#830000" : "#030031"};
    height: 34px; 
    border: 1px solid var(--log-cabin);
    border-radius: 8px;
    font-family: 'Lato', sans-serif;
    margin-top: 6px;
    width: 70%;
    transition: 0.5s;
    
    :hover {
        border-color: var(--gainsboro);
    }
`